export enum TaxFillingStatusEnum {
  FILER = "filer",
  DEPENDENT = "dependent",
  NON_FILER = "non_filer",
}
